import { useCoinIcons } from '@/lib/hooks/useCoinIcons'
import { Flex, Text, Image } from '@chakra-ui/react'

interface CryptoIconProps {
  symbol: string
  size?: number
}

const cryptoColors: Record<string, { bg: string, text: string }> = {
  BTC: { bg: '#F7931A', text: '#FFFFFF' },
  ETH: { bg: '#627EEA', text: '#FFFFFF' },
  SOL: { bg: '#14F195', text: '#000000' },
  BNB: { bg: '#F3BA2F', text: '#000000' },
  MATIC: { bg: '#8247E5', text: '#FFFFFF' },
  AVAX: { bg: '#E84142', text: '#FFFFFF' },
  DOT: { bg: '#E6007A', text: '#FFFFFF' },
  LINK: { bg: '#2A5ADA', text: '#FFFFFF' },
  UNI: { bg: '#FF007A', text: '#FFFFFF' },
  ATOM: { bg: '#2E3148', text: '#FFFFFF' },
  default: { bg: '#374151', text: '#FFFFFF' },
}

export function CryptoIcon({ symbol, size = 40 }: CryptoIconProps) {
  const { getIconUrl } = useCoinIcons()
  const iconUrl = getIconUrl(symbol)
  const colors = cryptoColors[symbol] || cryptoColors.default

  const compSize = size / 4
  const fontSize = size * 0.4

  // Show SVG icon if available
  if (iconUrl) {
    return (
      <Flex
        align="center"
        justify="center"
        overflow="hidden"
        w={compSize}
        h={compSize}
        borderRadius={size / 2}
      >
        <Image width={`${size}px`} height={`${size}px`} src={iconUrl} />
      </Flex>
    )
  }

  // Fallback to text-based icon
  return (
    <Flex
      align="center"
      justify="center"
      w={compSize}
      h={compSize}
      bg={colors.bg}
      borderRadius={size / 2}
    >
      <Text
        color={colors.text}
        fontSize={fontSize}
        fontWeight="bold"
      >
        {symbol.slice(0, 1).toUpperCase()}
      </Text>
    </Flex>
  )
}

export default CryptoIcon
